import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { privateRoutes, publicRoutes, webRoutes, lmsRoutes } from "./Routes/router";
import MainLayout from "./Layouts/MainLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAuthenticated,
  setLoginResponse,
} from "./store/reducers/userReducer";
import { setLoginResponseCheck } from "./utils/checkStorage";
import PageTitle from "./components/Common/PageTitle";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLogin = useSelector((state) => state.user?.isAuthenticated);
  const userData = useSelector((state) => state.user?.loginResponse?.user);
  const [isLoading, setIsLoading] = useState(true);
  
  const token = !!localStorage.getItem("access-token");
  const isAuthenticated = isLogin || token;
  const userType = userData ? JSON.parse(userData)?.userType : null;

  useEffect(() => {
    if (token) {
      const data = setLoginResponseCheck();
      dispatch(setLoginResponse(data));
      dispatch(setIsAuthenticated(true));
    }
    setIsLoading(false);
  }, [dispatch, token]);

  const renderPrivateRoutes = () => {
    return privateRoutes.map((route, index) => (
      <Route key={index} path={route.path} element={route.element} />
    ));
  };

  const renderWebRoutes = () => {
    return webRoutes.map((route, index) => (
      <Route key={index} path={route.path} element={route.element} />
    ));
  };

  const renderPublicRoutes = () => {
    return publicRoutes.map((route, index) => (
      <Route key={index} path={route.path} element={route.element} />
    ));
  };

  const renderLMSRoutes = () => {
    return lmsRoutes.map((route, index) => (
      <Route key={index} path={route.path} element={route.element} />
    ));
  };

  return (
    <>
      <PageTitle />
      <Routes location={location} key={location.pathname}>
        {isAuthenticated ? (
          userType === "mlm" ? (
            <>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                {renderPrivateRoutes()}
              </Route>
              {renderWebRoutes()}
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : userType === "normal" ? (
            <>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Navigate to="/acadamy-dashboard" replace />} />
                {renderLMSRoutes()}
              </Route>
              <Route path="/login" element={<Navigate to="/acadamy-dashboard" replace />} />
              <Route path="*" element={<Navigate to="/acadamy-dashboard" replace />} />
            </>
          ) : null
        ) : (
          <>
            {renderPublicRoutes()}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </>
  );
}

function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default Root;